/* eslint-disable no-unused-vars */
// React
import { useEffect, useState } from "react"

// API
import { TransferBahanJobMixApi } from "api"
import axios from "axios"

// Components
import { ActionButton, Alert, DataStatus } from "components"
import { Form, Modal } from "react-bootstrap"
import { DateConvert } from "utilities"

// Form
import { Formik } from "formik"
import * as yup from "yup"

// View Components
import { FormSection, InfoSection } from "../sections"

// View Functions
import { mappingData } from "pages/Inventory/Master/ItemBarang/functions"
import { useHistory, useLocation } from "react-router-dom"

const TransferModal = ({
  data,
  toggle,
  isCreate,
  title,
  toggleSuccess,
  getLastQtyTransfer,
}) => {
  // Hooks
  const location = useLocation();
  const history = useHistory();

  // States
  const [modal, setModal] = useState({
    loading: false,
    status: true,
  });
  const [dataForm, setDataForm] = useState({});
  const [dataDropdown, setDataDropdown] = useState({
    gudang: [],
    karyawan: [],
  });
  const [dataGudang, setDataGudang] = useState([]);
  const [dataKaryawan, setDataKaryawan] = useState([]);
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });

  const getGudang = (tgl) => {
    TransferBahanJobMixApi.getDropdownGudang({
      id_item_buaso: data.id_item_buaso,
      tgl: tgl,
    })
      .then((gudang) => {
        setDataGudang(mappingData(gudang, "gudang"));
      })
      .catch(() => {})
      .finally(() => {});
  };

  useEffect(() => {
    if (isCreate) {
      // Variables
      const tanggal = DateConvert(new Date()).default;

      setModal({
        loading: true,
        status: false,
      });

      axios
        .all([
          TransferBahanJobMixApi.no_baru(tanggal),
          TransferBahanJobMixApi.getDropdownKaryawan(),
        ])
        .then(
          axios.spread((no, karyawan) => {
            setDataForm({
              no: no.data.data,
              tanggal,
            });
            setDataKaryawan(mappingData(karyawan, "karyawan"));

            setModal({
              loading: false,
              status: true,
            });
          })
        )
        .catch(() => {
          setModal({
            loading: false,
            status: false,
          });
        });

      getGudang(tanggal);
    }

    // eslint-disable-next-line
  }, []);

  return (
    <Modal show={true} onHide={toggle}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6 className="m-0">
            {isCreate ? "Tambah" : "Detail"} Data {title}
          </h6>
        </Modal.Title>
      </Modal.Header>

      {modal.loading || !modal.status ? (
        <Modal.Body>
          <DataStatus
            loading={modal.loading}
            text={
              modal.loading
                ? "Memuat data..."
                : "Data gagal dimuat, tidak dapat menampilkan data"
            }
          />
        </Modal.Body>
      ) : (
        <Formik
          initialValues={{
            ...data,
            tgl_transfer_produksi_bahan: isCreate
              ? undefined
              : data.tgl_transfer_produksi_bahan,
            no_transfer_produksi_bahan: isCreate
              ? "Pilih tanggal terlebih dahulu"
              : data.no_transfer_produksi_bahan,
            qty_transfer: isCreate ? "" : data.qty_transfer,
            keterangan_transfer: isCreate ? "" : data.keterangan_transfer,
            qty_telah_ditransfer: data?.qty_transfer ?? 0,
            id_gudang_asal: "",
            id_gudang_tujuan: "",
            id_karyawan: "",
            stok_gudang: "",
            nama_satuan: "",
            nama_proyek: data?.nama_proyek ?? "-",
          }}
          validationSchema={yup.object().shape({
            tgl_permintaan_produksi_bahan: yup
              .date()
              .typeError("Masukkan Tanggal")
              .required("Masukkan Tanggal"),
            qty_transfer: yup
              .number()
              .max(
                parseFloat(data.qty_permintaan_produksi ?? 0) -
                  parseFloat(data.qty_transfer ?? 0),
                `Qty. Transfer wajib diisi maksimal ${
                  parseFloat(data.qty_permintaan_produksi ?? 0) -
                  parseFloat(data.qty_transfer ?? 0)
                }`
              )
              .test({
                name: "cek-gudang",
                message: "Stok gudang tidak mencukupi",
                test: (val, parent) =>
                  parent?.parent?.stok_gudang
                    ? parseFloat(parent?.parent?.stok_gudang) >=
                      parseFloat(val ?? 0)
                    : false,
              })
              .required("Qty. Transfer wajib diisi"),
            id_gudang_asal: yup.string().required("Pilih Gudang Asal"),
            id_gudang_tujuan: yup.string().required("Pilih Gudang Tujuan"),
            id_karyawan: yup.string().required("Pilih Karyawan"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            if (isCreate) {
              TransferBahanJobMixApi.save(values)
                .then(() => {
                  const totalQtyTransfer =
                    parseFloat(getLastQtyTransfer.qty_transfer) +
                    parseFloat(values.qty_transfer);

                  if (
                    totalQtyTransfer >=
                    getLastQtyTransfer?.qty_permintaan_produksi
                  ) {
                    history.push(
                      "/inventory/transaksi/transfer-bahan-job-mix/list-permintaan-bahan",
                      location.state
                    );
                  } else {
                    toggleSuccess();
                    toggle();
                  }
                })
                .catch(() => {
                  setAlertConfig({
                    show: true,
                    text: "Tambah data gagal",
                    variant: "danger",
                  });
                })
                .finally(() => setSubmitting(false));
            }
          }}
        >
          {({ handleSubmit, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Alert
                  show={alertConfig.show}
                  variant={alertConfig.variant}
                  text={alertConfig.text}
                  showCloseButton={true}
                  onClose={() => {
                    setAlertConfig({
                      ...alertConfig,
                      show: false,
                    });
                  }}
                />

                <InfoSection />
                <hr />
                <FormSection
                  buaso="bahan"
                  readOnly={!isCreate}
                  dropdown={dataDropdown}
                  getGudang={getGudang}
                  dataGudang={dataGudang}
                  dataKaryawan={dataKaryawan}
                />
              </Modal.Body>

              {isCreate && (
                <Modal.Footer>
                  <ActionButton
                    type="submit"
                    text="Simpan"
                    loading={isSubmitting}
                  />
                </Modal.Footer>
              )}
            </Form>
          )}
        </Formik>
      )}
    </Modal>
  );
};

export default TransferModal;
